import React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import WizardAlertEmergencyContacts from "./WizardAlertEmergencyContacts";
import WizardReportPetFound from "./WizardReportPetFound";
import { normalizeTagId } from "./Utils";

function TagWizardRouter() {
    const { tagId: urlTagId } = useParams();
    const [searchParams] = useSearchParams();
    const tagId = normalizeTagId(urlTagId);
    const fromApp = searchParams.get("app");

    // decide which wizard to display based on the tagId prefix
    if (tagId.startsWith("K")) {
        return <WizardAlertEmergencyContacts keyRingId={tagId} fromApp={fromApp} />;
    }

    return <WizardReportPetFound tagId={tagId} fromApp={fromApp} />;
}

export default TagWizardRouter;
